module.exports = __webpack_public_path__ + "img/lianmeng.0d8de540.png";